/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
Shopify.theme.jsFeaturedCollection = {
  init: function($section) {

    // Add settings from schema to current object
    Shopify.theme.jsFeaturedCollection = $.extend(this, Shopify.theme.getSectionData($section));

    if(this.enable_masonry_layout && !this.align_height && this.collection_style == 'grid') {
      Shopify.theme.applyMasonry();
    }

    if(this.collection_style == 'slider') {
      this.createSlider($section);
    }


  },
  createSlider: function($section) {

    let featuredCollectionSlider = $section.find('.featured-collection.layout--slider .slider-gallery');

    const slideData = {
      products_per_slide: this.products_per,
      products_available: this.products_available,
      products_limit: this.products_limit,
      cellAlign: "center",
      wrapAround: true
    }

    featuredCollectionSlider.each(function() {
      const $slider = $(this);

      if ($slider.data('flickity')) {
        $slider.flickity('destroy');
      }

      $slider.flickity({
        lazyLoad: 2,
        freeScroll: true,
        imagesLoaded: true,
        draggable: true,
        cellAlign: 'center',
        wrapAround: slideData.wrapAround,
        pageDots: false,
        contain: true,
        prevNextButtons: slideData.products_available > slideData.products_per_slide,
        initialIndex: 0,
        arrowShape: arrowShape,
        selectedAttraction: 0.2,
        friction: 0.8,
        on: {
          ready: function() {
            // Resize flickity when the slider is settled
            $slider.on('settle.flickity', function() {
              $slider.flickity('resize')
            });
          }
        }
      });
    });

  },
  unload: function($section) {
    let $slider = $section.find('.flickity-enabled');
    $slider.flickity('destroy');
  }
}

/******/ })()
;
